import React, { Component } from "react";

class AuthLayout extends Component {
  render() {
    return <div className="">{this.props.children}</div>;
  }
}

export default AuthLayout;
